import script from "./NoveltyAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./NoveltyAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./NoveltyAnalysis.vue?vue&type=style&index=0&id=6d6bc13f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d6bc13f"]])

export default __exports__